import React from 'react';

const WidgetContext = React.createContext();

export const WidgetProvider = WidgetContext.Provider;
export const WidgetConsumer = WidgetContext.Consumer;

export default WidgetContext;